import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { SearchIcon } from '~components/ui/icons';

export const SearchBar = ({
  search,
  handleSetSearch,
}: {
  search: string;
  handleSetSearch: (searchText: string) => void;
}) => {
  const [searchText, setSearchText] = useState(search);

  useEffect(() => {
    setSearchText(search);
  }, [search]);

  const updateSearch = (newSearch: string) => {
    const currentParams = new URLSearchParams(window.location.search);
    if (newSearch) {
      currentParams.set('search', newSearch);
    } else {
      currentParams.delete('search');
    }
    const newUrl = `${window.location.pathname}?${currentParams.toString()}`;
    history.replaceState({}, window.document.title, newUrl);
    handleSetSearch(newSearch);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchText(value);

    if (value === '') {
      updateSearch('');
    }
  };

  const handleSearchInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      updateSearch(searchText.trim());
    }
  };

  return (
    <InputGroup width="full" mt="12">
      <InputLeftElement pointerEvents="none" height="full">
        <SearchIcon color="gray.500" />
      </InputLeftElement>
      <Input
        type="text"
        placeholder={t('searchDevices')}
        value={searchText}
        onChange={handleInputChange}
        variant="outline"
        size="md"
        onKeyDown={handleSearchInputKeyDown}
      />
    </InputGroup>
  );
};
